import { getAuthorization } from 'controllers/controller';
import { setFlag } from 'controllers/flags';
import { getResumeURL } from 'services/talent/getResumeURL';
import { parseResumeService } from 'services/parseResume/parseResume';

export const resumeParser = async (files) => {
  const authorization = getAuthorization();

  if (files.length > 1) {
    setFlag('ResumeParserMultipleFilesError', true);
    return null;
  }

  const { data, status } = await parseResumeService(authorization, files);

  if (status !== 200) {
    const errType =
      data?.errors?.[0]?.errorFileParse || data?.errors?.[0]?.errorFormat;

    const errCode = errType?.errorCode;
    const errDescription = errType?.errorDescription;

    const err =
      errCode || errDescription
        ? `${errCode || 'Err'}: ${errDescription || 'Generic Error'}`
        : 'Generic Error';
    setFlag('ResumeParserError', err);
    return null;
  }

  const parsedData =
    data && data.result && data.result.length ? data.result[0] : null;

  const resumeLink = parsedData
    ? await getResumeURL(authorization, parsedData.filename)
    : null;

  return {
    json: data && data.result && data.result.length ? data.result[0] : null,
    resumeLink: resumeLink.data ? resumeLink.data.response : '',
    filename: parsedData ? parsedData.filename : '',
  };
};
